<mat-stepper  [orientation]="isHandset ? 'vertical' : 'horizontal'" linear #stepper>

  <!-- Step 1: Osnovni podaci o udruzi -->
  <mat-step [stepControl]="associationBasicInfoForm">
    <ng-template matStepLabel>I. Osnovni podaci o udruzi</ng-template>
    <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
      <mat-card-header>
        <mat-card-title><h5 class="mb-0">I. Osnovni podaci o udruzi</h5></mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <form [formGroup]="associationBasicInfoForm">
          <div class="mb-25">
            <mat-form-field class="full-width">
              <mat-label>Naziv udruge</mat-label>
              <input matInput formControlName="name" />
            </mat-form-field>
          </div>
          <div class="mb-25">
            <mat-form-field class="full-width">
              <mat-label>OIB</mat-label>
              <input matInput formControlName="oib"  />
            </mat-form-field>
          </div>
          <div class="mb-25">
            <mat-form-field class="full-width">
              <mat-label>RNO</mat-label>
              <input matInput formControlName="rno" />
            </mat-form-field>
          </div>
          <div class="mb-25">
            <mat-form-field class="full-width">
              <mat-label>Email</mat-label>
              <input matInput formControlName="email" />
            </mat-form-field>
          </div>
          <div class="mb-25">
            <mat-form-field class="full-width">
              <mat-label>Godina osnutka</mat-label>
              <input matInput formControlName="yearOfEstablishment" type="number" />
            </mat-form-field>
          </div>
          <div class="mb-25">
            <mat-form-field class="full-width">
              <mat-label>Datum upisa u matični registar</mat-label>
              <input matInput [matDatepicker]="picker" formControlName="dateOfRegistration" />
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="mb-25">
            <mat-form-field class="full-width">
              <mat-label>Registarski broj</mat-label>
              <input matInput formControlName="registrationNumber"  />
            </mat-form-field>
          </div>
          <div class="mb-25">
            <mat-form-field class="full-width">
              <mat-label>Registrirana pri</mat-label>
              <input matInput formControlName="registeredAuthority" />
            </mat-form-field>
          </div>
          <div class="mb-25">
            <mat-form-field class="full-width">
              <mat-label>Naziv banke</mat-label>
              <input matInput formControlName="bankName" />
            </mat-form-field>
          </div>
          <div class="mb-25">
            <mat-form-field class="full-width">
              <mat-label>Broj žiro-računa (IBAN)</mat-label>
              <input matInput formControlName="bankAccountNumber" />
            </mat-form-field>
          </div>
          <div class="mb-25">
            <mat-form-field class="full-width">
              <mat-label>Kontakt broj</mat-label>
              <input matInput formControlName="contactNumber" />
            </mat-form-field>
          </div>
          <div class="mb-25">
            <mat-form-field class="full-width">
              <mat-label>Web</mat-label>
              <input matInput formControlName="web"  />
            </mat-form-field>
          </div>

          <button mat-flat-button matStepperNext class="daxa" [disabled]="associationBasicInfoForm.invalid">Dalje</button>
        </form>
      </mat-card-content>
    </mat-card>
  </mat-step>

  <!-- Step 2: Podaci o sjedištu -->
  <mat-step [stepControl]="associationHeadquartersForm">
    <ng-template matStepLabel>II. Podaci o sjedištu</ng-template>
    <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
      <mat-card-header>
        <mat-card-title><h5 class="mb-0">II. Podaci o sjedištu</h5></mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <form [formGroup]="associationHeadquartersForm">
          <div class="mb-25">
            <mat-form-field class="full-width">
              <mat-label>Županija</mat-label>
              <input matInput formControlName="county" />
            </mat-form-field>
          </div>
          <div class="mb-25">
            <mat-form-field class="full-width">
              <mat-label>Poštanski broj i sjedište</mat-label>
              <input matInput formControlName="postalCodeAndHeadquarters" />
            </mat-form-field>
          </div>
          <div class="mb-25">
            <mat-form-field class="full-width">
              <mat-label>Adresa</mat-label>
              <input matInput formControlName="address"  />
            </mat-form-field>
          </div>

          <div>
            <button mat-flat-button matStepperPrevious class="mr-15">Nazad</button>
            <button mat-flat-button matStepperNext class="daxa" [disabled]="associationHeadquartersForm.invalid">Dalje</button>
          </div>
        </form>
      </mat-card-content>
    </mat-card>
  </mat-step>

  <!-- Step 3: Dodatni podaci -->
  <mat-step [stepControl]="associationDetailsForm">
    <ng-template matStepLabel>III. Dodatni podaci</ng-template>
    <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
      <mat-card-header>
        <mat-card-title><h5 class="mb-0">III. Dodatni podaci</h5></mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <form [formGroup]="associationDetailsForm">
          <div class="mb-25">
            <mat-form-field class="full-width">
              <mat-label>Ciljevi osnivanja sukladno Statutu</mat-label>
              <textarea matInput formControlName="objectivesAccordingToStatute" ></textarea>
            </mat-form-field>
          </div>
          <div class="mb-25">
            <mat-form-field class="full-width">
              <mat-label>Svrha i područje djelovanja</mat-label>
              <textarea matInput formControlName="purposeAndFieldOfOperation" ></textarea>
            </mat-form-field>
          </div>
          <div class="mb-25">
            <mat-form-field class="full-width">
              <mat-label>Djelatnosti prema Statutu</mat-label>
              <textarea matInput formControlName="activitiesAccordingToStatute" ></textarea>
            </mat-form-field>
          </div>

          <div>
            <button mat-flat-button matStepperPrevious class="mr-15">Nazad</button>
            <button mat-flat-button matStepperNext class="daxa" [disabled]="associationDetailsForm.invalid">Dalje</button>
          </div>
        </form>
      </mat-card-content>
    </mat-card>
  </mat-step>

  <!-- Step 4: Podaci o odgovornoj osobi (User) - only if creating -->
  @if (!isUpdating) {
    <mat-step [stepControl]="userFormGroup">
      <ng-template matStepLabel>IV. Podaci o odgovornoj osobi</ng-template>
      <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
        <mat-card-header>
          <mat-card-title><h5 class="mb-0">IV. Podaci o odgovornoj osobi</h5></mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <form [formGroup]="userFormGroup">
            <div class="mb-25">
              <mat-form-field class="full-width">
                <mat-label>Korisničko ime (e-mail)</mat-label>
                <input matInput formControlName="userName"  />
              </mat-form-field>
            </div>
            <div class="mb-25">
              <mat-form-field class="full-width">
                <mat-label>Ime</mat-label>
                <input matInput formControlName="firstName" />
              </mat-form-field>
            </div>
            <div class="mb-25">
              <mat-form-field class="full-width">
                <mat-label>Prezime</mat-label>
                <input matInput formControlName="lastName"  />
              </mat-form-field>
            </div>
            <div class="mb-25">
              <mat-form-field class="full-width">
                <mat-label>Lozinka</mat-label>
                <input matInput type="password" formControlName="password"  />
              </mat-form-field>
              @if (userFormGroup.get('password')!.hasError('minlength') && userFormGroup.get('password')!.touched) {
                <div class="error text-danger"
                  >
                  Lozinka mora imati najmanje 8 znakova.
                </div>
              }
            </div>
            <div class="mb-25">
              <mat-form-field class="full-width">
                <mat-label>Dužnost</mat-label>
                <input matInput formControlName="duty" />
              </mat-form-field>
            </div>
            <div>
              <button mat-flat-button matStepperPrevious class="mr-15">Nazad</button>
              <button mat-flat-button color="primary" (click)="onSubmit()">Spremi</button>
            </div>
          </form>
        </mat-card-content>
      </mat-card>
    </mat-step>
  }

  <!-- Step 4 (if updating): Potvrda -->
  @if (isUpdating) {
    <mat-step>
      <ng-template matStepLabel>Potvrda</ng-template>
      <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
        <mat-card-header>
          <mat-card-title><h5 class="mb-0">Ažuriranje podataka o udruzi</h5></mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div>
            <button mat-flat-button matStepperPrevious class="mr-15">Nazad</button>
            <button mat-flat-button color="primary" (click)="onSubmit()">Spremi</button>
          </div>
        </mat-card-content>
      </mat-card>
    </mat-step>
  }

</mat-stepper>